module.exports = __webpack_public_path__ + "img/cheeers_check.5b361d74.png";